import * as React from 'react';
import { SVGProps } from 'react';

const IconSmileStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 9H7v2h2V9ZM15 9h2v2h-2V9ZM16.026 12.772c-1.009 4.304-7.044 4.301-8.052.006l-1.948.457c1.492 6.355 10.457 6.354 11.948-.007l-1.948-.456Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
    />
  </svg>
);
export default IconSmileStrokedSizeM;
